import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { getCurrentDateTime } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 8,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 7,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const IpdActivePatientReportPdf = ({ data }) => {
  const calculateAge = (birthDateString) => {
    const birthDate = new Date(birthDateString);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();

    // Adjust age if the birth date hasn't occurred yet this year
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age;
  };
  console.log(data, 'RegisterData');
  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  const user = JSON.parse(localStorage.getItem('user'));
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Ipd Active Patient Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }} />
            <View style={styles.row}>
              <Text style={styles.textBold} content="Ipd Active Patient Report" />
            </View>
            <View style={styles.row}>
              <Text style={{...styles.columnHeader, width:'8%'}} content="Sr." />
              <Text style={styles.columnHeader} content="Date" />
              <Text style={styles.columnHeader} content="Uhid No" />
              <Text style={{ ...styles.columnHeader, width: '25%' }} content="Patient Name" />
              <Text style={styles.columnHeader} content="Age" />
              <Text style={styles.columnHeader} content="Gender" />
              <Text style={styles.columnHeader} content="Department" />
              <Text style={{ ...styles.columnHeader, width: '22%' }} content="Doctor" />
              <Text style={styles.columnHeader} content="Ward" />
              <Text style={styles.columnHeader} content="Room" />
              <Text style={{...styles.columnHeader, width:'8%'}} content="Bed" />
            </View>
            {data &&
              data.map((item, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'8%'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(item.date)} />
                  <Text style={styles.columnContent} content={item.uhid} />
                  <Text style={{ ...styles.columnContent, textAlign:'left', width: '25%' }}
                    content={`${item.patient?.name_suffix} ${item.patient?.first_name} ${item.patient?.last_name}`} />
                  <Text style={styles.columnContent} content={`${calculateAge(item.patient?.dob) || 'N/A'}`} />
                  <Text style={styles.columnContent} content={`${item.patient?.gender || 'N/A'}`} />
                  <Text style={styles.columnContent}
                    content={`${item.consultant_detail?.department?.department || 'N/A'}`} />
                  <Text style={{ ...styles.columnContent, textAlign:'left', width: '22%' }}
                    content={`${item.consultant_detail?.doctor?.name || 'N/A'}`} />
                  <Text style={styles.columnContent} content={`${item.consultant_detail?.room?.ward?.name || 'N/A'}`} />
                  <Text style={styles.columnContent} content={`${item.consultant_detail?.room?.room_no || 'N/A'}`} />
                  <Text style={{ ...styles.columnContent, width: '8%%' }} content={`${item.consultant_detail?.bed_no || 'N/A'}`} />
                </View>
              ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
